/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Helmet } from 'react-helmet';
import { type FC, useLayoutEffect } from 'react';

import { getAbrStudioTitle } from './is-abr-rebrand-enabled';

/** 默认浏览器页签标题；子页面可通过自有 Helmet 覆盖 */
export const AbrBrowserTitle: FC = () => {
  const title = getAbrStudioTitle(IS_OVERSEA);

  useLayoutEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
